var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 30.7,
    height: 30.7,
    rx: 4.35,
    stroke: "#565656",
    strokeOpacity: 0.2,
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0701 5.82149L26.3725 17.3333H28L16.0539 4L10.6398 9.96735V6.66667H7.97309V12.9137L4 17.3333H5.65131L16.0701 5.82149Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0719 6L7 15.9836V27H24.8973V15.9359H25L16.0719 6ZM12.2243 21.0936C12.0572 21.3107 11.9139 21.5479 11.7925 21.8032H9.79551C9.79551 19.7078 10.7384 18.8249 12.0523 18.5363C11.4021 18.1558 10.9651 17.4414 10.9651 16.6351C10.9651 15.4248 11.9487 14.4385 13.1619 14.4385C14.0179 14.4385 14.7591 14.926 15.1216 15.6381C13.6021 16.0354 12.4776 17.4167 12.4776 19.0554C12.4776 19.5604 12.5876 20.0524 12.7902 20.501C12.5804 20.6762 12.3933 20.8739 12.2243 21.0936ZM14.9091 20.9671C14.2589 20.5865 13.8219 19.8721 13.8219 19.0658C13.8219 17.8556 14.8054 16.864 16.0187 16.864C17.2319 16.864 18.2154 17.845 18.2154 19.0553C18.2154 19.8619 17.7781 20.587 17.1275 20.9676C18.4418 21.2559 19.385 22.1385 19.385 24.234H12.6524C12.6524 22.1385 13.5952 21.2557 14.9091 20.9671ZM20.2447 21.8032C20.1234 21.5478 19.9798 21.3106 19.8125 21.0933C19.6434 20.8738 19.4553 20.6763 19.2458 20.5014C19.4484 20.0526 19.5591 19.5605 19.5591 19.0553C19.5591 17.3894 18.3973 15.9903 16.8396 15.6198C17.2049 14.9153 17.9416 14.4333 18.7915 14.4333C20.0047 14.4333 20.9882 15.4143 20.9882 16.6247C20.9882 17.4313 20.551 18.1564 19.9004 18.5369C21.2146 18.8253 22.1579 19.7079 22.1579 21.8033H20.2447V21.8032Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesThree);
export default __webpack_public_path__ + "static/media/features-three.1c3c14a6.svg";
export { ForwardRef as ReactComponent };